import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xwhpw468rz: FaireBrandEntity = {
  token: "b_xwhpw468rz",
  type: "brand",
  name: "Social Statement",
  avatarUrl:
    "https://cdn.faire.com/fastly/215282d52f0606fcd204b68f2e669aa24280b2f42405eb6a97c901ab2a0d6f62.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6300f5497583a77bb0cb634134f100df8fce3ae741d7800cc2940c374677eabf.png",
  logoUrl:
    "https://cdn.faire.com/fastly/215282d52f0606fcd204b68f2e669aa24280b2f42405eb6a97c901ab2a0d6f62.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6300f5497583a77bb0cb634134f100df8fce3ae741d7800cc2940c374677eabf.png",
  location: "Fayetteville , AR, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 43,
  isInsider: true,
  description:
    "Social Statement is an all women owned business coming from the amazing college town of Fayetteville, Arkansas specializing in greek, gameday, and every day apparel & accessories. We love creating unique products that your customers will LOVE! ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:43.806Z",
    importedBy: "entity-db-cli",
  },
};
